import { useGetUnderwearPromotions } from '@/api/underwear-promotion/underwear-promotion.hooks';
import { AddUnderwearPromotion } from '@/components/underwear-promotion/AddUnderwearPromotion';
import { UnderwearPromotionCard } from '@/components/underwear-promotion/UnderwearPromotionCard';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { AppPageLayout } from '@/layouts/AppPageLayout';

export const UnderwearPromotionPage = () => {
  const { promotions, isError, isLoading } = useGetUnderwearPromotions();

  if (isLoading) return <LoadingScreen />;
  if (isError || !promotions) return <ErrorScreen />;

  return (
    <AppPageLayout
      title="Promotions culottes"
      description="Gestion des promotions in-app"
    >
      <div className="flex flex-col gap-4 h-full">
        <div className="flex justify-end shrink-0 mt-4">
          <AddUnderwearPromotion />
        </div>

        <div className="flex flex-wrap gap-4 overflow-y-auto pb-10">
          {promotions.length === 0 && (
            <p className="text-zinc-400 text-sm">Aucune promotion</p>
          )}
          {promotions.map((promotion) => (
            <UnderwearPromotionCard key={promotion.id} {...promotion} />
          ))}
        </div>
      </div>
    </AppPageLayout>
  );
};
